import { render, staticRenderFns } from "./TrainingPlanItemPlaceholder.vue?vue&type=template&id=135fde21&scoped=true&"
import script from "./TrainingPlanItemPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemPlaceholder.vue?vue&type=style&index=0&id=135fde21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fde21",
  null
  
)

export default component.exports